import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HttpModule } from '@angular/http';
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { FormsModule } from '@angular/forms';
import { BaseApiService } from './base-api.service';
import { Ng4LoadingSpinnerModule } from 'ng4-loading-spinner';
import { ToastModule } from 'ng2-toastr/ng2-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DashboardComponent } from './dashboard/dashboard.component';
import { AppRoutes } from "./app.routing";
import { MatFormFieldModule, MatChipsModule, MatCardModule, MatOptionModule, MatSelectModule, MatInputModule,MatTableModule,MatDatepickerModule,MatNativeDateModule } from '@angular/material';
import { UploadMasterComponent } from './upload-master/upload-master.component';
import { DropdownModule } from "ngx-dropdown";
import { ViewMasterComponent } from './view-master/view-master.component';
import { CategoryPipe } from './category.pipe';
import { OrderrByPipe } from './orderby.pipe';
import { Ng2TableModule } from 'ng2-table/ng2-table';
import { PaginationModule } from 'ng2-bootstrap/ng2-bootstrap';  
import { ExcelServiceService } from './excel-service.service';
import { NotificationComponent } from './notification/notification.component'; 
import { DateAdapter, MatDateFormats } from '@angular/material';
import { Ng2AutoCompleteModule } from 'ng2-auto-complete';
import { MyDatePickerModule } from 'mydatepicker';
import { UserPositionComponent } from './user-position/user-position.component';
@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    DashboardComponent,
    UploadMasterComponent,
    ViewMasterComponent,
    CategoryPipe,
    OrderrByPipe,
    NotificationComponent,
    UserPositionComponent,
  ],
  imports: [
    MyDatePickerModule,
    Ng2AutoCompleteModule,
    Ng2TableModule,
    PaginationModule.forRoot(),
    BrowserModule,
    MatFormFieldModule,
    MatChipsModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatInputModule,
    MatCardModule,
    MatOptionModule,
    MatSelectModule,
    FormsModule,
    HttpModule,
    DropdownModule,
    Ng4LoadingSpinnerModule.forRoot(),
    RouterModule.forRoot(AppRoutes, { useHash: true }),
    ToastModule.forRoot(),
    BrowserAnimationsModule
  ],
  providers: [BaseApiService,ExcelServiceService  
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts